import { render, staticRenderFns } from "./TechnicalFeaturesSiding.vue?vue&type=template&id=0920dccc"
import script from "./TechnicalFeaturesSiding.vue?vue&type=script&lang=js"
export * from "./TechnicalFeaturesSiding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports